module.exports = __webpack_public_path__ + "media/svg/cf-290bd76f.svg";